class PubNubService {
  init(instance) {
    this.instance = instance
  }
}

export default new PubNubService()



// WEBPACK FOOTER //
// ./src/services/pubnub.js